import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import strings from '../../strings/strings.json'
import { checkLicense } from 'api/api_service';
import { ISystemInfo } from 'types';
import moment from 'moment-jalaali';
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../state/actions";
import { productDetails } from 'api/api_service';
import { IProductDetails } from 'types';
import Layout from 'components/layout';
import WarningMobile from 'components/warning_mobile';
import { isMobile } from 'react-device-detect'

export default function Home() {
    const history = useHistory()
    const dispatch = useDispatch();
    const [data, setData] = useState<ISystemInfo>()
    const [productDetail, setProductDetail] = useState<IProductDetails>()
    const [width, setWidth] = useState<number>(window.innerWidth)
    const [isMobileDevice, setIsMobile] = useState<boolean>(false)
    const [isGoOn, setIsGoOn] = useState<boolean>(false)

    useEffect(() => {
        productDetails()
            .then(res => {
                if (res.status === 200 && res.data.success)
                    setProductDetail(res.data.data)
            })
        checkLicense()
            .then(res => {
                if (res.status === 200) {
                    if (res.data.data) {
                        setData(res.data.data)
                    } else {
                        dispatch(showSnackbar({ "open": true, severity: "warning", msg: `${strings.license_error}` }));
                    }
                }
            })

        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, [])

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }

    const renderData = (title: string, subTitle: string) => {
        return (
            <div className='flex justify-center flex-col items-center'>
                <span className='font-bold primary_text_color'>{title}</span>
                <span className='secondry_text_color'>{subTitle}</span>
            </div>
        )
    }

    const confrimHandler = () => {

        if (data !== undefined && productDetail !== undefined) {
            if (productDetail.os === "Linux")
                history.push('/disk')
            else
                history.push('/chooseFile')
        }
        else
            dispatch(showSnackbar({ "open": true, severity: "warning", msg: `${strings.license_error}` }));
    }

    if (isMobile && !isMobileDevice && !isGoOn)
        setIsMobile(true)

    return (
        <Layout>
            {
                !isMobileDevice ?
                    (
                        <div dir='rtl' className='centered w-full px-10'>
                            <div className='flex items-center justify-center flex-col w-full'>
                                <div className='sm:mt-10'><img src={require('../../assets/icons/mri.svg').default} alt="Icon" /></div>
                                <div className='flex flex-col justify-center items-center m-10'>
                                    <span className='primary_text_color font-bold text-lg'>{strings.home_processDeviceTitle}</span>
                                    <span className='secondry_text_color'>{strings.home_processDeviceSubTitle}</span>
                                </div>
                                <div>
                                    <button className='flex text-white rounded-full px-8 py-3 primary_bg_color' onClick={() => confrimHandler()}>
                                        <img className='ml-3' src={require('../../assets/icons/radar.svg').default} alt="Icon" />
                                        <span>{strings.home_startScan}</span>
                                    </button>
                                </div>
                                {
                                    data !== undefined &&
                                    <div className='grid grid-cols-4 w-full text-center justify-around border border-gray-100 rounded-lg py-5 mt-10'>
                                        <div className='border-l md:col-span-1 sm:col-span-3 sm:border-l-0 xs:col-span-5 xs:border-l-0'>{renderData(strings.home_softwareVersion, (data !== undefined && data) ? data.version : '-')}</div>
                                        <div className='border-l md:col-span-1 sm:col-span-2 sm:border-l-0 xs:col-span-5 xs:mt-5'>{renderData(strings.home_expireLicense, (data !== undefined && data) ? moment(data.expire_time_str).format('jYYYY/jM/jD') : '-')}</div>
                                        <div className='border-l md:col-span-1 sm:col-span-3 sm:border-l-0 sm:mt-5 xs:col-span-5 xs:mt-5 xs:border-l-0'>{renderData(strings.home_productName, (data !== undefined && data) ? data.product : '-')}</div>
                                        <div className='md:col-span-1 sm:col-span-2 sm:border-l-0 sm:mt-5 xs:col-span-5 xs:mt-5 xs:border-l-0'>{renderData(strings.home_plan, (data !== undefined && data) ? data.plan : '-')}</div>
                                    </div>
                                }
                            </div>
                        </div>
                    )
                    :
                    (
                        <WarningMobile
                            goOn={() => {
                                setIsMobile(false)
                                setIsGoOn(true)
                            }
                            }
                        />
                    )
            }
        </Layout>
    )
}
